import React from "react";
import CardReviewSkeleton from "../card_review/cardReview";
import Skeleton from "../skeleton";

const Dekstop = () => (
	<div className="container">
		<div className="section-title">
			<div className="title-reviews">
				<Skeleton
					width="425px"
					height="30px"
				/>
				<Skeleton
					width="506px"
					height="20px"
				/>
			</div>
		</div>

		{
			Array.from({ length: 5 }, (index, idx) => (
				<CardReviewSkeleton key={idx} />
			))
		}

		<style jsx>
			{`
				.container{
						display: flex;
						justify-content: center;
						flex-direction: column;
						align-items: center;
						width: 880px;
						max-width: 880px;
				}
				.section-title{
						max-width: 880px;
						width: 100%;
				}
				.title-reviews{
						display: flex;
						gap: 8px;
						flex-direction: column;
				}
				.card{
						max-width: 888px;
						padding: 16px;
						margin-top: 20px;
            border-radius: 8px;
						border: 1px solid #dfe3e8;
				}
				.list-reviews{
						display: flex;
						gap: 20px;
				}
				.product{
						display: flex;
						flex-direction: column;
						align-items: center;
				}
				.section-bs{
						display: flex;
						gap: 10px;
				}
				.section-reviews{
						max-width: 598px;
				}
				.profile{
						display: flex;
						justify-content: space-between;
						align-items: center;
				}
				.section-place{
						display: flex;
						gap: 10px;
				}
				hr{
						margin-top: 10px;
						border: 1px solid #dfe3e8;
				}
				.comment-section{
						display: flex;
						justify-content: space-between;
				}
		`}
		</style>
	</div>
);

export default Dekstop;
